import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  metadata: {
    favicon: "/favicon.svg",
  },
  theme: {
    customCss: {
      ":root": {
        "--top-header-height": "0px",
        "--top-nav-height": "0px",
        "--banner-height": "0px",
        "--header-height": "0px",
        "--scroll-padding": "10px",
      },
      "header[data-pagefind-ignore='all']": {
        display: "none",
      },
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "book",
      items: [
        "/introduction",
        "/authentication",
        {
          type: "link",
          to: "/api",
          label: "API Reference",
          icon: "code",
        },
      ],
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
    },
  ],
  docs: {
  defaultOptions: {
    copyPage: true // Enable copy button for all pages
  },
  llms: {
    llmsTxt: true,
    llmsTxtFull: true,
    includeProtected: true,
  },
}
};

export default config;